export default __webpack_public_path__ + "static/media/facebook.7e665371.svg";